/**
 * Trang xem thử nhãn KPI của đơn — chỉ chạy ở bản phát triển (`_dev` tự chặn
 * ở bản phát hành).
 *
 * Đường vào: `/kpi-scope` — KHÔNG phải `/_dev/kpi-scope`. Tên file mở đầu bằng
 * `_` trong TanStack Router là lớp bọc KHÔNG có đoạn đường dẫn, nên `_dev` chỉ
 * là chỗ gom + chặn ở bản phát hành, không hiện ra trên URL.
 *
 * Vì sao đáng có: bài kiểm khẳng định được "ô chọn có đủ bốn dòng" và "chọn
 * dòng nào thì gửi đi giá trị nào", nhưng không trả lời được câu về bố cục —
 * nhãn dài nhất ("Tự mua tự bán (kê số)") có nằm gọn một dòng trong ô chọn
 * không, ở cả màn rộng lẫn màn hẹp. Đó là thứ phải NHÌN. Đo tại chỗ 25/08:
 * chữ cần 118px, ô 176px còn thừa — nên ô GIỮ NGUYÊN 176px, không nới.
 *
 * Trang tự cấp quyền `kpi.scope.write` vào kho quyền rồi TRẢ LẠI nguyên trạng
 * khi rời trang, để người đang đăng nhập thật không bị đổi quyền sau lưng.
 * Bấm đổi nhãn ở đây sẽ báo lỗi — đơn là đơn bịa, không có trong CSDL.
 */
import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";

import { PageHeader } from "@/components/PageHeader";
import { KpiScopeRow } from "@/features/orders/components/KpiScopeRow";
import type { Order } from "@/features/orders/api";
import { useAuthV2 } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";

export const Route = createFileRoute("/_dev/kpi-scope")({
  component: KpiScopeDemo,
});

const NHAN = ["normal", "hq", "internal", "self_dealt"] as const;

function don(kpiScope: string): Order {
  return { id: `xem-thu-${kpiScope}`, kpiScope } as Order;
}

function KpiScopeDemo() {
  useEffect(() => {
    const truoc = useAuthV2.getState().permissions;
    useAuthV2.setState({
      permissions: new Set([...truoc, ACTION.KpiScopeWrite]),
    });
    return () => useAuthV2.setState({ permissions: truoc });
  }, []);

  return (
    <div className="space-y-6 p-8" data-testid="kpi-scope-demo">
      <PageHeader
        title="Nhãn KPI của đơn"
        description="Bốn nhãn cạnh nhau — dùng để nhìn bố cục, không phải để đổi dữ liệu"
      />
      {NHAN.map((n) => (
        <div key={n} className="rounded border p-3">
          <KpiScopeRow order={don(n)} />
        </div>
      ))}
    </div>
  );
}
